/**
 * Copyright (c) 2021
 *
 * Contains the representation of a OptionTypeEnumType
 *
 * @summary OptionTypeEnumType enum definition
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2021-08-17 10:21:56
 * Last modified  : 2021-08-17 16:40:37
 */

const OptionTypeEnumType = {
    INTEGER: 'integer',
    DECIMAL: 'decimal',
    STRING: 'string',
    BOOLEAN: 'boolean',
}

export default OptionTypeEnumType
